/* eslint-disable max-len */
import { React } from 'react'
import Pagination from '../../../../../components/Pagination'
import { formatAdjustedDate } from '../../../../../CommonMethods/formatDate'
const Table = ({ OutwardTransferStudentList,
    searchParams,
    setSearchParams,
    setPageLoading,
    OutwardTransferStudentCount }) => {
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;

    return (
        <div class="-mx-1">
            <div class="overflow-auto pb-[62px] scroll-bar px-1">
                <div class="flex mb-1 w-full" style={{'display':'inline-block'}}>
                    <table aria-label="Outside Table" class="w-full  mt-1" id="admin-table">
                        <thead>
                            <tr>
                                <th class="w-[12%]">
                                    <span class="flex items-center text-f2 font-semibold text-[#031624] justify-start">Student ID
                                    </span>
                                </th>
                                <th class="w-[15%]">
                                    <span class="flex items-center text-f2 font-semibold text-[#031624] justify-start">Student Name
                                    </span>
                                </th>

                                <th class="w-[10%]">
                                    <span class="flex items-center text-f2 font-semibold text-[#031624] justify-start">Transfer ID
                                    </span>
                                </th>
                                <th class="w-[8%]">
                                    <span class="flex items-center text-f2 font-semibold text-[#031624] justify-start">Passcode
                                    </span>
                                </th>
                                <th class="w-[14%]">
                                    <span class="flex items-center text-f2 font-semibold text-[#031624] justify-start">Transferred to
                                    </span>
                                </th>
                                <th class="w-[14%]">
                                    <span class="flex items-center text-f2 font-semibold text-[#031624] justify-start">Transferred Date
                                    </span>
                                </th>
                                <th class="w-[13%]">
                                    <span class="flex items-center text-f2 font-semibold text-[#031624] justify-start">Transferred by
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody >
                            {OutwardTransferStudentList?.map((Outward) => (
                                <>
                                    <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                    <tr class="group">
                                        <td class="text-start">{Outward?.student_id || '-'}</td>
                                        <td class="text-start">{Outward?.student_name}</td>

                                        <td class="text-start">{Outward?.transfer_id}</td>
                                        <td class="text-start  capitalize break-all">{Outward?.passcode}</td>
                                        <td class="text-start">{Outward?.transfers_to}</td>
                                        <td class="text-start">{formatAdjustedDate(Outward?.transferred_on)}</td>

                                        <td class="text-start">{Outward?.transferred_by}</td>
                                    </tr>
                                </>))}
                        </tbody>
                        {OutwardTransferStudentCount === 0 && (
                            <tbody>
                                <tr>
                                    <td style={{ 'line-height': '100px'}} colspan="7" className="no-records-message">
                                        {noSearchOrFilter ? `No outward transfers added yet` : 'No matching records found.'}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
            {OutwardTransferStudentCount > 10 && <Pagination
                TotalCount={OutwardTransferStudentCount}
                totalPageNumber={Math?.ceil(OutwardTransferStudentCount / 10)}
                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                handleOnClickPageNumber={handleOnClickPageNumber}
            />}
        </div>
    )
}
export default Table;   